import { Api } from '@cems-eco/core/src/services/api/api.service';
import { api, apiNet } from '@cems-eco/core/src/services/api';
import { getService } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

class BaseReadingApi {
    BASE_URL: string;
    api: Api;
    
    constructor() {
        this.BASE_URL = "/reading";
        this.api = getService<Api>(environment.nexus, {
            box: api,
            cloud: apiNet,
        });
    }

    async allByEquipment(equipmentId: any, params = {}): Promise<any> {
        const url = this.BASE_URL + '/equipment/' + equipmentId + '/30m'
        return await this.api.get<any>(url, params);
    }

    async getOneMinBy30min(sensor_id: string, timestamp: string): Promise<any> {
        const url = this.BASE_URL + '/by30min/' + sensor_id + '/' + timestamp;
        return await this.api.get<any>(url);
    }

    async all(): Promise<any> {
        return await this.api.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await this.api.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await this.api.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await this.api.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await this.api.delete<any>(`${this.BASE_URL}/${id}`);
    }

}

export default new BaseReadingApi();

